export default __webpack_public_path__ + "static/16-2d9b977f38a9b5c48d5f761a2194fb4e.webp";